import { Filter } from '@/types/product-filter';

/** Matches `itemSize` in `product-filter.tsx`. */
export const PRODUCT_FILTER_ITEM_SIZE_PX = 46;

/** Matches `maxItemsToShow` in `product-filter.tsx`. */
export const PRODUCT_FILTER_MAX_VISIBLE_ITEMS = 5;

/** Desktop filter title row (`@lg:flex` header). */
const PRODUCT_FILTER_HEADER_HEIGHT_PX = 24;

/** Search input block: `@lg:mt-6` + input + `mb-3`. */
const PRODUCT_FILTER_SEARCH_FIELD_HEIGHT_PX = 76;

/** Price interval block: checkbox + slider + min/max inputs. */
const PRODUCT_FILTER_INTERVAL_HEIGHT_PX = 140;

export const getProductFilterListHeight = (optionCount: number) =>
  Math.min(optionCount, PRODUCT_FILTER_MAX_VISIBLE_ITEMS) * PRODUCT_FILTER_ITEM_SIZE_PX;

/** Approximate rendered height of a desktop filter section for skeleton placeholders. */
export const getProductFilterSkeletonHeight = (filter: Filter) => {
  let height = PRODUCT_FILTER_HEADER_HEIGHT_PX + getProductFilterListHeight(filter.options.length);

  if (filter.isSearchField) {
    height += PRODUCT_FILTER_SEARCH_FIELD_HEIGHT_PX;
  }

  if (filter.isInterval) {
    height += PRODUCT_FILTER_INTERVAL_HEIGHT_PX;
  }

  return height;
};
